// generated by the plop

import { UnknownError, UUID } from 'symbols';
import { OrderModel, OrderModelExpectBackend } from '../../symbols';

export class GetOrderById {
  static type = '[orderManage] GetOrderById';

  constructor(public id: UUID) {
  }
}

export class GetOrderByIdSuccess {
  static type = '[orderManage] GetOrderByIdSuccess';

  constructor(public order: OrderModel) {
  }
}

export class GetOrderByIdFail {
  static type = '[orderManage] GetOrderByIdFail';

  constructor(public error: unknown) {
  }
}

export class SetCurrentOrderId {
  static type = '[orderManage] SetCurrentOrderId';

  constructor(public id: UUID) {
  }
}


export class UpdateLocalOrder {
  static type = '[orderManage] UpdateLocalOrder';

  constructor(public order: OrderModel) {
  }
}

export class DeleteLocalOrder {
  static type = '[orderManage] DeleteLocalOrder';

  constructor(public id: UUID) {
  }
}

export class UpdateOrder {
  static type = '[orderManage] UpdateOrder';

  constructor(public id: UUID, public order: OrderModelExpectBackend, public force: boolean) {
  }
}

export class UpdateOrderSuccess {
  static type = '[orderManage] UpdateOrderSuccess';

  constructor(public order: OrderModel) {
  }
}

export class UpdateOrderFail {
  static type = '[orderManage] UpdateOrderFail';

  constructor(public error: unknown) {
  }
}

export class CreateOrder {
  static type = '[orderManage] CreateOrder';

  constructor(public order: OrderModelExpectBackend) {
  }
}

export class CreateOrderSuccess {
  static type = '[orderManage] CreateOrderSuccess';

  constructor(public order: OrderModel) {
  }
}

export class CreateOrderFail {
  static type = '[orderManage] CreateOrderFail';

  constructor(public error: unknown) {
  }
}


// added by plop
export class IssuedOrder {
  static type = '[orderManage] IssuedOrder';

  constructor(public orderId: UUID) {
  }
}


export class IssuedOrderSuccess {
static type = '[orderManage] IssuedOrderSuccess';
  constructor(public order: OrderModel) {
  }
}


export class IssuedOrderFail {
static type = '[orderManage] IssuedOrderFail';
  constructor(public error: UnknownError) {
  }
}

// added by plop
export class SetNotConfirmedOrder {
  static type = '[orderManage] SetNotConfirmedOrder';

  constructor(public order: OrderModelExpectBackend) {
  }
}


export class SetNotConfirmedOrderSuccess {
static type = '[orderManage] SetNotConfirmedOrderSuccess';
  constructor(public order: OrderModel) {
  }
}


export class SetNotConfirmedOrderFail {
static type = '[orderManage] SetNotConfirmedOrderFail';
  constructor(public error: UnknownError) {
  }
}
